
export default {
  name: 'GiftPromotionList',
  data () {
    return {
      loading: false,
      giftPromotions: []
    }
  },
  created () {
    this.fetchGiftPromotions()
  },
  methods: {
    async fetchGiftPromotions () {
      this.loading = true
      try {
        const res = await this.axios.get('/admin/promotions')
        if (res.data.code === 200) {
          // 只显示有满赠规则的活动（gift_rule 不为空）
          this.giftPromotions = (res.data.data || []).filter(p => p.gift_rule)
          // 获取每个活动的商品数量
          for (const promo of this.giftPromotions) {
            try {
              const productsRes = await this.axios.get(`/admin/promotions/${promo.id}/products`)
              if (productsRes.data.code === 200) {
                this.$set(promo, 'product_count', productsRes.data.data.length)
              }
            } catch (e) {
              this.$set(promo, 'product_count', 0)
            }
          }
        }
      } catch (err) {
        console.error('获取满赠活动失败:', err)
        this.$toast?.fail?.('获取活动列表失败')
      } finally {
        this.loading = false
      }
    },
    goToCreate () {
      this.$router.push('/admin/gift-promotions/create')
    },
    goToEdit (id) {
      console.log('点击编辑活动, id:', id)
      this.$router.push({
        path: `/admin/gift-promotions/${id}/edit`
      }).catch(err => {
        console.error('路由跳转失败:', err)
      })
    },
    giftRuleText (promo) {
      const ruleMap = {
        same: `买 ${promo.buy_quantity || 1} 送 ${promo.gift_quantity || 1} 同款`,
        sku: `买 ${promo.buy_quantity || 1} 送 ${promo.gift_quantity || 1} 其他商品`,
        gift: `买 ${promo.buy_quantity || 1} 送 ${promo.gift_quantity || 1} 赠品`
      }
      return ruleMap[promo.gift_rule] || ''
    },
    formatDate (date) {
      if (!date) return ''
      const d = new Date(date)
      return `${d.getMonth() + 1}/${d.getDate()}`
    }
  }
}
